export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5" data-testid="logo">
    <svg width="34" height="34" viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="16" fill="#065F46" />
      <path d="M32 13 L47 33 H38.5 V50 H25.5 V33 H17 Z" fill="#F7F7F2" />
    </svg>
    <span
      className={`font-heading text-xl font-extrabold tracking-tight ${
        light ? "text-cream" : "text-ink"
      }`}
    >
      Local<span className={light ? "text-emerald-300" : "text-pine"}>Lift</span>
    </span>
  </span>
);
